import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';

const TimerCircularTimer = ({ progress, expiry }) => {
  const remainingTime = expiry - progress;
  return (
    <Box position="relative" display="inline-flex" marginRight="10px">
      <CircularProgress
        variant="determinate"
        value={100 - (progress / expiry) * 100}
        style={{
          transform: 'scaleX(-1) rotate(-90deg)',
        }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="primary"
        >{`${remainingTime}s`}</Typography>
      </Box>
    </Box>
  );
};

export default TimerCircularTimer;
